
import Vue from 'vue';
import { TransformedEmMap } from '~/transforms/transformModules';
import { generateLocationsSchema } from '~/utility/jsonld/locations';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedEmMap['data'],
      required: true,
    },
  },

  data() {
    return {
      showMap: false,
    };
  },

  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: generateLocationsSchema(this.data),
        },
      ],
    };
  },

  mounted() {
    if (this.data.map.locations?.length) {
      this.showMap = true;
    }
  },
});
